function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import ProductCard from "segments/desktop/core-components/product-card/product-card";
import { StyledProductCardsSideBySideTextAndAssetComponent } from "./product-cards-side-by-side-text-and-asset-component.scss";
const ProductCardsSideBySideTextAndAssetComponent = ({ cards })=>/*#__PURE__*/ _jsx(StyledProductCardsSideBySideTextAndAssetComponent, {
        className: "product-cards-side-by-side-text-and-asset-component",
        children: cards === null || cards === void 0 ? void 0 : cards.map((card)=>/*#__PURE__*/ _jsx(ProductCard, _object_spread({
                isCondensed: cards.length > 1
            }, card)))
    });
export default ProductCardsSideBySideTextAndAssetComponent;
